import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7434b457"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "ieo-order-list"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "status"
};
const _hoisted_6 = {
  key: 1,
  style: {
    "color": "#03ad73"
  }
};
const _hoisted_7 = {
  key: 2,
  style: {
    "color": "#d1514b"
  }
};
const _hoisted_8 = {
  key: 3,
  style: {
    "color": "#d1514b"
  }
};
const _hoisted_9 = {
  class: "info"
};
const _hoisted_10 = {
  key: 0,
  class: "tag",
  style: {
    "--color": "#D04C64",
    "--bColor": "#FBF3F1"
  }
};
const _hoisted_11 = {
  key: 1,
  class: "tag",
  style: {
    "--color": "#04AC92",
    "--bColor": "#E4F7F1"
  }
};
const _hoisted_12 = {
  class: "date"
};
const _hoisted_13 = {
  class: "label"
};
const _hoisted_14 = {
  class: "num"
};
const _hoisted_15 = {
  class: "label"
};
const _hoisted_16 = {
  class: "num"
};
const _hoisted_17 = {
  class: "label"
};
const _hoisted_18 = {
  class: "num"
};
const _hoisted_19 = {
  class: "label"
};
const _hoisted_20 = {
  class: "num"
};
const _hoisted_21 = {
  class: "label"
};
const _hoisted_22 = {
  class: "num"
};
const _hoisted_23 = {
  class: "label"
};
import { ref, onMounted } from 'vue';
import store from '@/store';
import { useI18n } from 'vue-i18n';
import { ieoOrder } from '@/apis';
import { fmtNumber } from '@/util';
import BigNumber from 'bignumber.js';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
export default {
  __name: 'IEOOrderList',
  props: {
    coinId: {
      type: Number,
      default: 0
    },
    kline: {
      type: String,
      default: ''
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    let page = 1;
    const finished = ref(true);
    const loading = ref(false);
    const list = ref([]);

    const fmtTableData = list => {
      dayjs.extend(utc);
      dayjs.extend(timezone);
      return list?.map(item => {
        return {
          id: item.id,
          key: item.id,
          date: dayjs(item.createdAt * 1000).tz("America/New_York").format("YYYY-MM-DD HH:mm:ss"),
          buySpot: item.marketName,
          total: fmtNumber(item.tradeNum),
          buyPrice: fmtNumber(item.ieoPrice),
          number: fmtNumber(item.ieoNum),
          status: item.state,
          closeType: item.tradeMarketName,
          type: item.side,
          // 1 買入 2 賣入
          oldPrice: item.ieoPrice,
          up: true
        };
      });
    };

    const init = (index = 0) => {
      if (store.state.token === '') {
        return;
      }

      let loadPage = index;

      if (index < 1) {
        loadPage = page + 1;
      }

      loading.value = true;
      ieoOrder({
        side: 0,
        page: loadPage
      }).then(res => {
        if (res.code === 200 && res.data && res.data.list) {
          if (index < 1) {
            page += 1;
            list.value = [...list.value, ...fmtTableData(res.data.list)];
          } else {
            page = 1;
            list.value = fmtTableData(res.data.list);
          }

          if (res.data.total > list.value.length) {
            finished.value = false;
          } else {
            finished.value = true;
          }
        }
      }).finally(() => {
        loading.value = false;
      });
    };

    const getValuation = number => {
      const last = store.state.market[props.kline] ? store.state.market[props.kline].last : 0;
      return fmtNumber(BigNumber(number).multipliedBy(last).toFixed(8));
    };

    const getProfit = index => {
      const {
        number,
        oldPrice
      } = list.value[index];
      const oldValue = BigNumber(number).multipliedBy(oldPrice).toNumber();

      if (oldValue <= 0) {
        return 0;
      }

      const last = store.state.market[props.kline] ? store.state.market[props.kline].last : 0;
      const newValue = BigNumber(number).multipliedBy(last).toNumber();
      const res = BigNumber(newValue).minus(oldValue).dividedBy(oldValue).multipliedBy(100);

      if (res.toNumber() >= 0) {
        list.value[index].up = true;
      } else {
        list.value[index].up = false;
      }

      return res.toFixed(2);
    };

    onMounted(() => {
      init(1);
    });
    expose({
      init
    });
    return (_ctx, _cache) => {
      const _component_van_col = _resolveComponent("van-col");

      const _component_van_row = _resolveComponent("van-row");

      const _component_van_empty = _resolveComponent("van-empty");

      const _component_van_list = _resolveComponent("van-list");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_list, {
        finished: finished.value,
        loading: loading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => loading.value = $event),
        "finished-text": _unref(t)('finished'),
        "loading-text": _unref(t)('loading'),
        onLoad: init
      }, {
        default: _withCtx(() => [list.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(list.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "ieo-order-item"
          }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.buySpot), 1), _createElementVNode("div", _hoisted_5, [item.status === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(_toDisplayString(_unref(t)('waitReview')), 1)], 64)) : item.status === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('buySuccess')), 1)) : item.status === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('reviewReject')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('canceled')), 1))])]), _createElementVNode("div", _hoisted_9, [item.type === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('sell')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)('buy')), 1)), _createElementVNode("div", _hoisted_12, _toDisplayString(item.date), 1)]), _createVNode(_component_van_row, null, {
            default: _withCtx(() => [_createVNode(_component_van_col, {
              span: "8",
              class: "data-item"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('tradeVol')), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(item.total), 1)]),
              _: 2
            }, 1024), _createVNode(_component_van_col, {
              span: "8",
              class: "data-item",
              style: {
                "text-align": "center"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('closeCurrency')), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(item.closeType), 1)]),
              _: 2
            }, 1024), _createVNode(_component_van_col, {
              span: "8",
              class: "data-item",
              style: {
                "text-align": "right"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('buyPrice')), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(item.buyPrice), 1)]),
              _: 2
            }, 1024), _createVNode(_component_van_col, {
              span: "8",
              class: "data-item"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('number')) + "(ERS)", 1), _createElementVNode("div", _hoisted_20, _toDisplayString(item.number), 1)]),
              _: 2
            }, 1024), _createVNode(_component_van_col, {
              span: "8",
              class: "data-item",
              style: {
                "text-align": "center"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('valuation')) + "(USDT)", 1), _createElementVNode("div", _hoisted_22, _toDisplayString(getValuation(item.number)), 1)]),
              _: 2
            }, 1024), _createVNode(_component_van_col, {
              span: "8",
              class: "data-item",
              style: {
                "text-align": "right"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('profitP')), 1), _createElementVNode("div", {
                class: "num",
                style: _normalizeStyle({
                  color: item.up ? '#03ad73' : '#d1514b'
                })
              }, _toDisplayString(getProfit(index)) + " %", 5)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)])]);
        }), 128)) : (_openBlock(), _createBlock(_component_van_empty, {
          key: 1,
          description: _unref(t)('nothing')
        }, null, 8, ["description"]))]),
        _: 1
      }, 8, ["finished", "loading", "finished-text", "loading-text"])]);
    };
  }

};